export default "__VITE_ASSET__lBMn7Zbo__"